<template>
  <div class="ele-body">
    <el-row :gutter="15">
      <el-col :lg="6" :md="8" :sm="24">
        <el-card shadow="never" body-style="padding: 20px;">
          <div class="profile-user">
            <div class="profile-avatar">{{ avatarLetter }}</div>
            <div class="profile-name">{{ form.username }}</div>
            <div class="ele-text-secondary">管理员账号</div>
          </div>
          <el-divider class="profile-divider" />
          <ul class="profile-meta">
            <li>
              <span class="label">手机</span>
              <span class="value" :title="form.mobile">{{ form.mobile }}</span>
            </li>
            <li>
              <span class="label">邮箱</span>
              <span class="value" :title="form.email">{{ form.email }}</span>
            </li>
            <li>
              <span class="label">登录IP</span>
              <span class="value" :title="form.login_ip">{{ form.login_ip }}</span>
            </li>
            <li>
              <span class="label">谷歌验证</span>
              <el-tag size="mini" :type="form.is_google === 1 ? 'success' : 'info'">
                {{ form.is_google === 1 ? '已绑定' : '未绑定' }}
              </el-tag>
            </li>
            <li>
              <span class="label">密码状态</span>
              <el-tag size="mini" :type="pwdTagType">{{ pwdStatusText }}</el-tag>
            </li>
          </ul>
        </el-card>
      </el-col>

      <el-col :lg="18" :md="16" :sm="24">
        <el-card shadow="never" body-style="padding: 0 20px 20px;">
          <el-tabs v-model="active" class="profile-tabs">
            <el-tab-pane label="基本资料" name="info">
              <el-form
                ref="infoForm"
                class="profile-form"
                :model="infoForm"
                :rules="infoRules"
                label-width="100px"
                size="small">
                <el-form-item label="登录账号:">
                  <el-input :value="form.username" disabled />
                </el-form-item>
                <el-form-item label="手机号码:" prop="mobile">
                  <el-input
                    v-model.trim="infoForm.mobile"
                    maxlength="11"
                    clearable
                    placeholder="请输入" />
                </el-form-item>
                <el-form-item label="电子邮箱:" prop="email">
                  <el-input
                    v-model.trim="infoForm.email"
                    maxlength="100"
                    clearable
                    placeholder="请输入" />
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" size="small" :loading="infoLoading" @click="saveInfo">保存资料</el-button>
                </el-form-item>
              </el-form>
            </el-tab-pane>

            <el-tab-pane label="修改密码" name="password">
              <el-alert
                v-if="form.pwd_expired || form.pwd_remind"
                :title="pwdAlertTitle"
                :type="form.pwd_expired ? 'error' : 'warning'"
                :closable="false"
                show-icon
                class="profile-alert" />
              <el-form
                ref="pwdForm"
                class="profile-form"
                :model="pwdForm"
                :rules="pwdRules"
                label-width="100px"
                size="small"
                @keyup.enter.native="savePwd">
                <el-form-item label="旧密码:" prop="oldPassword">
                  <el-input
                    v-model="pwdForm.oldPassword"
                    show-password
                    clearable
                    placeholder="请输入" />
                </el-form-item>
                <el-form-item label="新密码:" prop="newPassword">
                  <el-input
                    v-model="pwdForm.newPassword"
                    show-password
                    clearable
                    placeholder="请输入" />
                </el-form-item>
                <el-form-item label="确认密码:" prop="rePassword">
                  <el-input
                    v-model="pwdForm.rePassword"
                    show-password
                    clearable
                    placeholder="请输入" />
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" size="small" :loading="pwdLoading" @click="savePwd">保存密码</el-button>
                </el-form-item>
              </el-form>
            </el-tab-pane>

            <el-tab-pane label="谷歌验证器" name="google">
              <div class="google-bar">
                <div>
                  <div class="google-title">Google Authenticator</div>
                  <div class="ele-text-secondary">
                    {{ form.is_google === 1 ? '当前已绑定，更换需校验旧验证码' : '未绑定，请生成秘钥并完成验证' }}
                  </div>
                </div>
                <el-button
                  v-if="!showGoogle"
                  type="primary"
                  size="small"
                  plain
                  @click="openGoogle">
                  {{ form.is_google === 1 ? '更换绑定' : '开始绑定' }}
                </el-button>
              </div>

              <el-form
                v-show="showGoogle"
                class="profile-form google-form"
                label-width="100px"
                size="small">
                <template v-if="form.is_google === 1">
                  <el-form-item label="旧秘钥:">
                    <el-input :value="form.google_token" disabled />
                  </el-form-item>
                  <el-form-item label="旧验证码:">
                    <el-input
                      v-model.trim="google.oldgooglecode"
                      clearable
                      maxlength="8"
                      placeholder="请输入" />
                  </el-form-item>
                </template>
                <el-form-item label="新秘钥:">
                  <div class="secret-row">
                    <el-input
                      v-model="google.secret"
                      clearable
                      placeholder="请输入" />
                    <el-button type="primary" size="small" :loading="yzmLoading" @click="getYzm">随机生成</el-button>
                  </div>
                </el-form-item>
                <el-form-item label="二维码:">
                  <div v-if="!google.qrCodeUrl" class="ele-text-secondary">请先点击「随机生成」</div>
                  <div v-else class="google-qr-wrap">
                    <img :src="google.qrCodeUrl" alt="google-qr" class="google-qr" />
                    <div class="ele-text-secondary">使用 Google Authenticator 扫码后填写验证码</div>
                  </div>
                </el-form-item>
                <el-form-item label="新验证码:">
                  <el-input
                    v-model.trim="google.googlecode"
                    clearable
                    maxlength="8"
                    placeholder="请输入" />
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" size="small" :loading="googleLoading" @click="saveGoogle">验证并绑定</el-button>
                  <el-button size="small" @click="resetGoogleForm">取消</el-button>
                </el-form-item>
              </el-form>
            </el-tab-pane>
          </el-tabs>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import setting from '@/config/setting';
import validate from 'ele-admin/packages/validate';

export default {
  name: 'UserProfile',
  data() {
    return {
      active: 'info',
      form: {
        username: '',
        mobile: '',
        email: '',
        login_ip: '',
        is_google: 0,
        google_token: '',
        pwd_expired: false,
        pwd_remind: false,
        pwd_left_days: null,
        password_rule: { min: 6, max: 32, require_special: false }
      },
      infoForm: {
        mobile: '',
        email: ''
      },
      infoRules: {
        mobile: [{ pattern: validate.phone, message: '手机号格式不正确', trigger: 'blur' }],
        email: [{ pattern: validate.email, message: '邮箱格式不正确', trigger: 'blur' }]
      },
      infoLoading: false,
      pwdForm: {
        oldPassword: '',
        newPassword: '',
        rePassword: ''
      },
      pwdLoading: false,
      showGoogle: false,
      google: {
        secret: '',
        qrCodeUrl: '',
        googlecode: '',
        oldgooglecode: ''
      },
      yzmLoading: false,
      googleLoading: false
    };
  },
  computed: {
    avatarLetter() {
      const name = String(this.form.username || '').trim();
      return name ? name.charAt(0).toUpperCase() : 'U';
    },
    passwordRule() {
      const rule = this.form.password_rule || {};
      return {
        min: rule.min || 6,
        max: rule.max || 32,
        require_special: !!rule.require_special
      };
    },
    pwdRules() {
      return {
        oldPassword: [{ required: true, message: '请输入', trigger: 'blur' }],
        newPassword: [
          { required: true, message: '请输入', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                return callback(new Error('请输入'));
              }
              if (value.length < this.passwordRule.min) {
                return callback(new Error(`密码长度不能少于${this.passwordRule.min}位`));
              }
              if (value.length > this.passwordRule.max) {
                return callback(new Error(`密码长度不能超过${this.passwordRule.max}位`));
              }
              if (this.passwordRule.require_special && !/[\W_]/.test(value)) {
                return callback(new Error('密码必须包含特殊字符'));
              }
              callback();
            },
            trigger: 'blur'
          }
        ],
        rePassword: [
          {
            required: true,
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (!value) {
                return callback(new Error('请再次输入新密码'));
              }
              if (value !== this.pwdForm.newPassword) {
                return callback(new Error('两次输入密码不一致'));
              }
              callback();
            }
          }
        ]
      };
    },
    pwdStatusText() {
      if (this.form.pwd_expired) {
        return '已过期';
      }
      if (this.form.pwd_remind && this.form.pwd_left_days != null) {
        return `${this.form.pwd_left_days}天后过期`;
      }
      return '正常';
    },
    pwdTagType() {
      if (this.form.pwd_expired) {
        return 'danger';
      }
      if (this.form.pwd_remind) {
        return 'warning';
      }
      return 'success';
    },
    pwdAlertTitle() {
      if (this.form.pwd_expired) {
        return '密码已过期，请立即修改';
      }
      return `密码将在 ${this.form.pwd_left_days} 天后过期，建议尽快修改`;
    }
  },
  mounted() {
    this.getUserInfo();
  },
  methods: {
    getUserInfo() {
      if (!setting.userUrl) {
        return;
      }
      this.$http.get(setting.userUrl).then((res) => {
        const result = setting.parseUser ? setting.parseUser(res.data) : res.data;
        if (result.code !== 0) {
          this.$message.error(result.msg || '加载失败');
          return;
        }
        const data = result.data || {};
        this.form = Object.assign({}, this.form, data);
        this.infoForm = {
          mobile: data.mobile,
          email: data.email
        };
        this.$store.dispatch('user/setUser', data);
      }).catch((e) => {
        this.$message.error(e.message);
      });
    },
    saveInfo() {
      this.$refs.infoForm.validate((valid) => {
        if (!valid) {
          return;
        }
        this.infoLoading = true;
        this.$http.post('/index/updateUserInfo', {
          mobile: this.infoForm.mobile,
          email: this.infoForm.email
        }).then((res) => {
          this.infoLoading = false;
          if (res.data.code !== 0) {
            this.$message.error(res.data.msg || '保存失败');
            return;
          }
          this.$message.success(res.data.msg || '保存成功');
          this.getUserInfo();
        }).catch((e) => {
          this.infoLoading = false;
          this.$message.error(e.message);
        });
      });
    },
    savePwd() {
      this.$refs.pwdForm.validate((valid) => {
        if (!valid) {
          return;
        }
        this.pwdLoading = true;
        this.$http.post('/index/updatePwd', {
          oldPassword: this.pwdForm.oldPassword,
          newPassword: this.pwdForm.newPassword
        }).then((res) => {
          this.pwdLoading = false;
          if (res.data.code !== 0) {
            this.$message.error(res.data.msg || '修改失败');
            return;
          }
          this.$message.success(res.data.msg || '修改成功');
          this.pwdForm = { oldPassword: '', newPassword: '', rePassword: '' };
          this.$nextTick(() => {
            if (this.$refs.pwdForm) {
              this.$refs.pwdForm.clearValidate();
            }
          });
          this.getUserInfo();
        }).catch((e) => {
          this.pwdLoading = false;
          this.$message.error(e.message);
        });
      });
    },
    openGoogle() {
      this.showGoogle = true;
    },
    getYzm() {
      this.yzmLoading = true;
      this.$http.get('/index/getYzm').then((res) => {
        this.yzmLoading = false;
        if (res.data.code !== 0) {
          this.$message.error(res.data.msg || '生成失败');
          return;
        }
        const data = res.data.data || {};
        this.google.secret = data.secret;
        this.google.qrCodeUrl = data.qrCodeUrl;
      }).catch((e) => {
        this.yzmLoading = false;
        this.$message.error(e.message);
      });
    },
    saveGoogle() {
      if (!this.google.secret) {
        this.$message.warning('请先生成新秘钥');
        return;
      }
      if (!this.google.googlecode) {
        this.$message.warning('请输入');
        return;
      }
      if (this.form.is_google === 1 && !this.google.oldgooglecode) {
        this.$message.warning('请输入');
        return;
      }
      this.googleLoading = true;
      this.$http.post('/index/saveGoogle', {
        googlecode: this.google.googlecode,
        oldgooglecode: this.google.oldgooglecode,
        user_google_secret_key: this.google.secret
      }).then((res) => {
        this.googleLoading = false;
        if (res.data.code !== 0) {
          this.$message.error(res.data.msg || '绑定失败');
          return;
        }
        this.$message.success(res.data.msg || '绑定成功');
        this.resetGoogleForm();
        this.getUserInfo();
      }).catch((e) => {
        this.googleLoading = false;
        this.$message.error(e.message);
      });
    },
    resetGoogleForm() {
      this.showGoogle = false;
      this.google = {
        secret: '',
        qrCodeUrl: '',
        googlecode: '',
        oldgooglecode: ''
      };
    }
  }
};
</script>

<style scoped>
.ele-body {
  padding-bottom: 0;
}
.el-card {
  margin-bottom: 15px;
}
.profile-user {
  text-align: center;
}
.profile-avatar {
  width: 64px;
  height: 64px;
  margin: 0 auto;
  border-radius: 50%;
  background: #409eff;
  color: #fff;
  font-size: 26px;
  font-weight: 600;
  line-height: 64px;
}
.profile-name {
  margin-top: 12px;
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}
.profile-divider {
  margin: 16px 0;
}
.profile-meta {
  margin: 0;
  padding: 0;
  list-style: none;
}
.profile-meta li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
  font-size: 13px;
  line-height: 20px;
}
.profile-meta li:last-child {
  margin-bottom: 0;
}
.profile-meta .label {
  flex: 0 0 auto;
  color: #909399;
}
.profile-meta .value {
  flex: 1;
  min-width: 0;
  text-align: right;
  color: #606266;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.profile-tabs ::v-deep .el-tabs__header {
  margin-bottom: 18px;
}
.profile-form {
  max-width: 420px;
}
.profile-form ::v-deep .el-form-item {
  margin-bottom: 18px;
}
.profile-alert {
  margin: 0 0 16px;
  max-width: 420px;
}
.google-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
  max-width: 560px;
}
.google-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 4px;
}
.google-form {
  max-width: 480px;
}
.secret-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.secret-row .el-input {
  flex: 1;
}
.google-qr-wrap {
  line-height: 1.6;
}
.google-qr {
  width: 148px;
  height: 148px;
  display: block;
  margin-bottom: 8px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
}
</style>
